module.exports = __webpack_public_path__ + "img/table-setting.4ffea1ca.svg";